function pickFirst(...values) {
  return values.find((v) => v !== undefined && v !== null && String(v).trim() !== '');
}

function buildProfileName(partner) {
  const profile = partner?.profile || {};
  const firstName = pickFirst(profile.firstName, profile.first_name);
  const lastName = pickFirst(profile.lastName, profile.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || pickFirst(profile.email, profile.uid) || '-';
}

function normalizePartners(payload) {
  if (Array.isArray(payload?.partners)) return payload.partners;
  if (payload?.partners && typeof payload.partners === 'object') return Object.values(payload.partners);
  if (Array.isArray(payload)) return payload;
  return [];
}

export function mapPartnersResponseToDto(payload) {
  return normalizePartners(payload).map((partner, index) => ({
    key: String(pickFirst(partner.uid, `partner-${index}`)),
    uid: String(pickFirst(partner.uid) || '').trim(),
    profileUid: String(pickFirst(partner?.profile?.uid, partner?.profile?.id) || '').trim(),
    profileName: buildProfileName(partner),
    status: pickFirst(partner.status) || '-',
    referralCode: pickFirst(partner.referralCode, partner.referral_code) || '-',
    commissionPlanUid: String(pickFirst(partner?.commissionPlan?.uid) || '').trim(),
    commissionPlanName: pickFirst(partner?.commissionPlan?.name) || '-',
    walletBalanceMinor: String(partner?.wallet?.balance ?? ''),
    walletBalanceMicro: String(pickFirst(partner?.wallet?.balanceMicro, partner?.wallet?.balance) ?? ''),
    walletCurrency: pickFirst(partner?.wallet?.currency) || 'USD',
    created: pickFirst(partner.created, partner.createdAt, partner.created_at),
  }));
}

export function buildPartnersRequestDto({ status, commissionPlanUid, limit, offset } = {}) {
  const dto = { limit: limit || 100, offset: offset || 0 };
  if (status) dto.status = status;
  if (commissionPlanUid) dto.commissionPlanUid = commissionPlanUid;
  return dto;
}
